<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Visualizar Produtor" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-producer v-if="!$loader.loading" :producer="producer" readonly />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import type Producer from '@/types/Producer'
import FormProducer from '@/views/producers/form-producer.vue'
import ProducerService from '@/services/ProducerService'

export default defineComponent({
  components: {
    TPageTitle,
    FormProducer,
  },
  data() {
    return {
      producer: { } as Producer,
    }
  },
  created() {
    this.fetchProducer()
  },
  methods: {
    async fetchProducer() {
      try {
        this.$loader.increment()
        const { data } = await (new ProducerService()).show(this.$route.params.id as string)
        this.producer = data
      } catch (error) {
        this.$snackbar.show(
          'Não foi possível buscar o produtor',
          'error',
        )

        throw error
      } finally {
        this.$loader.decrement()
      }
    },
  },
})
</script>
